import { render, staticRenderFns } from "./botton.vue?vue&type=template&id=2fc149c9&"
import script from "./botton.vue?vue&type=script&lang=js&"
export * from "./botton.vue?vue&type=script&lang=js&"
import style0 from "./botton.vue?vue&type=style&index=0&lang=less&scepod=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc149c9')) {
      api.createRecord('2fc149c9', component.options)
    } else {
      api.reload('2fc149c9', component.options)
    }
    module.hot.accept("./botton.vue?vue&type=template&id=2fc149c9&", function () {
      api.rerender('2fc149c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminalOrdering/change_superior/form/botton.vue"
export default component.exports